
import { motion } from 'framer-motion';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  const getPageNumbers = () => {
    const pages: (number | string)[] = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.2 }}
      className="flex items-center justify-center gap-2 mt-12"
    >
      {/* Prev */}
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-gray-400 hover:border-neon-purple hover:text-neon-purple transition-all cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <i className="ri-arrow-left-s-line w-5 h-5 flex items-center justify-center"></i>
      </button>

      {/* Pages */}
      {getPageNumbers().map((page, idx) => (
        <button
          key={idx}
          onClick={() => typeof page === 'number' && onPageChange(page)}
          disabled={typeof page === 'string'}
          className={`w-10 h-10 flex items-center justify-center rounded-xl text-sm font-medium transition-all cursor-pointer ${
            page === currentPage
              ? 'bg-gradient-neon text-white shadow-neon-purple'
              : typeof page === 'string'
              ? 'text-gray-600 cursor-default'
              : 'bg-white/5 border border-white/10 text-gray-400 hover:border-neon-purple hover:text-neon-purple'
          }`}
        >
          {page}
        </button>
      ))}

      {/* Next */}
      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-gray-400 hover:border-neon-purple hover:text-neon-purple transition-all cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <i className="ri-arrow-right-s-line w-5 h-5 flex items-center justify-center"></i>
      </button>
    </motion.div>
  );
}
